import DetailController from './detail-view.controller';

require('./detail-view.scss');

const DetailComponent = {
    selector: 'sbDetail',
    controller: DetailController,
    template: require('./detail-view.html'),
};

export default DetailComponent;



// WEBPACK FOOTER //
// ./src/app/detail/detail-view/index.js